<template>
  <div>
    <div
      class="flex flex-col modal-container"
      :class="{'hidden': !isShown}"
    >
      <div class="modal-content-container">
        <div class="modal-content-header">
          <slot name="title" />
          <div
            class="icon-transparent-bg"
            @click="$emit('update:isShown', false)"
          >
            <vs-icon
              icon="close"
              color="#FF7F57"
              size="small"
            />
          </div>
        </div>
        <div class="modal-content-body">
          <slot name="body" />
        </div>
        <div class="modal-content-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShown: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.datepicker {
  width: 100% !important;
}

/deep/.mx-input-wrapper {
  @apply p-2 px-4 #{!important};
}

.modal-container {
  @apply w-full h-full py-5 fixed top-0 left-0 justify-center bg-black bg-opacity-50;

  z-index: 1000;
}

.modal-content-container {
  @apply w-2/4 m-5 h-full flex flex-col self-center rounded-lg overflow-auto;

  background-color: #F1F1FD;
}

.modal-content-header {
  @apply p-5 mb-5 flex flex-row justify-between items-center rounded-b-2xl bg-white;
}

.modal-content-body {
  @apply p-2 px-5 flex flex-col;
}

.modal-content-footer {
  @apply p-5 flex flex-row justify-end;
}

.icon-transparent-bg {
  @apply p-1 flex flex-col justify-center rounded-lg cursor-pointer;

  background-color: rgba(255, 127, 87, 0.2);
}
</style>
